/* GOPSHOP 7.16 – Scroll-Story „Dein Einkaufsagent“ (sections/gop-flow.liquid): die Bühne bleibt stehen, die Konsole wechselt
   mit dem Scrollen zwischen Anfrage → Agenten-Radar → Angebot → Sendungsverfolgung. Details (Kategorien, Linien, Zeilen,
   Sendungsfortschritt) folgen dem Scroll-Fortschritt innerhalb der Szene. Nur aktiv ohne „Weniger Bewegung“; Scroll-Arbeit
   nur, solange der Bereich sichtbar ist. Während die Bühne steht, pausiert der Rauch (html.gop-flow-on, assets/gop-smoke.js). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function init(root) {
    if (root.__gfl) return;
    root.__gfl = true;
    var $ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var txts = $('[data-gfl-txt]');
    var views = $('[data-gfl-v]');
    var dots = $('[data-gfl-dot]');
    var chips = $('[data-gfl-chip]');
    var links = $('[data-gfl-link]');
    var nodes = $('[data-gfl-node]');
    var rows = $('[data-gfl-row]');
    var stops = $('[data-gfl-stop]');
    var send = root.querySelector('[data-gfl-send]');
    var accept = root.querySelector('[data-gfl-accept]');
    var done = root.querySelector('[data-gfl-done]');
    var status = root.querySelector('[data-gfl-status]');
    var typed = root.querySelector('[data-gfl-typed]');
    var track = root.querySelector('.gfl__track');
    var pin = root.querySelector('.gfl__pin');
    var n = Math.min(txts.length, views.length);
    if (n < 2 || !track || !pin) return;

    var en = root.getAttribute('data-en') === '1';
    var STATUS = en
      ? ['Checking availability …', 'Comparing prices …', 'Matching offer found']
      : ['Verfügbarkeit wird geprüft …', 'Preise werden verglichen …', 'Passendes Angebot gefunden'];
    var wishes = [];
    try { wishes = JSON.parse(root.getAttribute('data-wishes') || '[]'); } catch (e) {}
    wishes = wishes.map(function (w) { return String(w || '').trim(); }).filter(Boolean);

    root.classList.add('is-pin');
    var de = document.documentElement;
    var cur = -1, raf = 0, live = false;
    var last = { chips: -1, nodes: -1, rows: -1, stops: -1, st: -1, e: -1, t: -1 };

    function measure() {
      var r = track.getBoundingClientRect();
      var ph = pin.offsetHeight || window.innerHeight;
      var span = Math.max(1, r.height - ph);
      return { r: r, ph: ph, span: span, p: clamp(-r.top / span, 0, 1) };
    }

    function setCount(list, k, key, cls) {
      if (last[key] === k) return;
      last[key] = k;
      list.forEach(function (el, j) { el.classList.toggle(cls || 'is-in', j < k); });
    }

    function scene(i, l) {
      /* 1 – Anfrage: Kategorien erscheinen nacheinander, am Ende „Anfrage senden“ */
      if (i === 0) {
        setCount(chips, Math.floor(clamp(l / 0.75, 0, 1) * chips.length + 0.001), 'chips');
        if (send) send.classList.toggle('is-press', l > 0.86);
      } else {
        setCount(chips, chips.length, 'chips');
      }
      /* 2 – Radar: Linien wachsen zu den Kategorien, Knoten leuchten auf */
      if (i === 1) {
        var lit = 0;
        links.forEach(function (ln, k) {
          var v = clamp((l * 1.25 - k * 0.11) / 0.28, 0, 1);
          ln.style.strokeDashoffset = (1 - v).toFixed(3);
          if (v >= 0.98) lit++;
        });
        setCount(nodes, lit, 'nodes', 'is-lit');
        var st = l < 0.34 ? 0 : l < 0.7 ? 1 : 2;
        if (status && last.st !== st) {
          last.st = st;
          status.textContent = STATUS[st];
          status.classList.toggle('is-ok', st === 2);
        }
      } else if (i > 1 && last.nodes !== nodes.length) {
        links.forEach(function (ln) { ln.style.strokeDashoffset = '0'; });
        setCount(nodes, nodes.length, 'nodes', 'is-lit');
      }
      /* 3 – Angebot: Zeilen nacheinander, dann „Angebot annehmen“ */
      if (i === 2) {
        setCount(rows, Math.floor(clamp(l / 0.7, 0, 1) * rows.length + 0.001), 'rows');
        if (accept) accept.classList.toggle('is-in', l > 0.74);
      } else if (i > 2) {
        setCount(rows, rows.length, 'rows');
        if (accept) accept.classList.add('is-in');
      }
      /* 4 – Lieferung: Paket fährt die Strecke ab, Stationen leuchten, am Ende „Zugestellt“ */
      if (i === 3) {
        var t = clamp(l / 0.85, 0, 1);
        if (Math.abs(t - last.t) > 0.002) {
          last.t = t;
          root.style.setProperty('--gfl-t', t.toFixed(3));
        }
        setCount(stops, Math.min(stops.length, 1 + Math.floor(t * (stops.length - 1) + 0.02)), 'stops');
        if (done) done.classList.toggle('is-in', t >= 0.999);
      }
    }

    function update() {
      raf = 0;
      var m = measure();
      var f = m.p * n;
      var i = Math.min(n - 1, Math.floor(f));
      var l = clamp(f - i, 0, 1);
      if (i === n - 1) l = clamp((m.p * n - i) / 0.85, 0, 1); /* letzte Szene: etwas früher fertig */
      if (i !== cur) {
        root.setAttribute('data-s', String(i));
        txts.forEach(function (el, k) { el.classList.toggle('is-on', k === i); el.classList.toggle('is-past', k < i); });
        views.forEach(function (el, k) { el.classList.toggle('is-on', k === i); el.classList.toggle('is-past', k < i); });
        dots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); el.classList.toggle('is-done', k < i); });
        root.classList.toggle('is-last', i === n - 1);
        cur = i;
        typeLoop();
      }
      scene(i, l);
      /* Einflug der Konsole, solange der Bereich noch hereinscrollt */
      var e = m.r.top > 0 ? clamp(1 - m.r.top / (window.innerHeight * 0.9), 0, 1) : 1;
      if (Math.abs(e - last.e) > 0.004) {
        last.e = e;
        root.style.setProperty('--gfl-e', e.toFixed(3));
      }
      de.classList.toggle('gop-flow-on', m.r.top <= 1 && m.r.bottom >= m.ph - 1);
    }

    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    /* Tipp-Animation der Beispiel-Wünsche (nur in Szene 1, nur sichtbar) */
    var tw = { i: 0, c: 0, dir: 1, tid: 0 };
    function typeLoop() {
      clearTimeout(tw.tid);
      if (!typed || wishes.length < 1 || !live || cur !== 0 || document.hidden) return;
      var word = wishes[tw.i % wishes.length];
      var delay = 55;
      if (tw.dir > 0) {
        tw.c++;
        if (tw.c >= word.length) { tw.c = word.length; tw.dir = -1; delay = 1500; }
      } else {
        tw.c -= 2;
        delay = 22;
        if (tw.c <= 0) { tw.c = 0; tw.dir = 1; tw.i++; delay = 380; }
      }
      typed.textContent = word.slice(0, tw.c);
      tw.tid = setTimeout(typeLoop, delay);
    }
    document.addEventListener('visibilitychange', typeLoop);

    new IntersectionObserver(function (ent) {
      var vis = ent[0].isIntersecting;
      if (vis && !live) {
        live = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll();
        typeLoop();
      } else if (!vis && live) {
        live = false;
        clearTimeout(tw.tid);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        de.classList.remove('gop-flow-on');
      }
    }, { rootMargin: '150px 0px' }).observe(root);

    /* Schrittleiste antippen → zur Szene scrollen */
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var k = +d.getAttribute('data-gfl-dot') || 0;
        var m = measure();
        window.scrollTo({ top: window.pageYOffset + m.r.top + ((k + 0.45) / n) * m.span, behavior: 'smooth' });
      });
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-gfl]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
